import { API_URLS } from '@helpers/api';
import { ReactComponent as SvgFavouriteStar } from '@img/icons/favourite-star.svg';
import React from 'react';
import S from './FavouriteToggle.styles';
const FavouriteToggle = ({ className, id, initialValue, isLoggedIn, }) => {
    const [value, setValue] = React.useState(initialValue);
    const [showTooltip, setShowTooltip] = React.useState(false);
    return (React.createElement(S.Button, { className: className, "data-active": value, "data-show-tooltip": showTooltip, onClick: async (event) => {
            event.preventDefault();
            const newValue = !value;
            if (isLoggedIn) {
                // Optimistic update.
                setValue(newValue);
                // Hit API and set status based on response.
                const result = await setFavourite({ id, value: newValue });
                if (result.value !== newValue) {
                    setValue(result.value);
                }
            }
            else {
                setShowTooltip(!showTooltip);
            }
        } },
        React.createElement(S.Text, null, "Toggle Favourite Status"),
        React.createElement(S.Icon, { as: SvgFavouriteStar }),
        React.createElement(S.Tooltip, null, "Please log in to use this feature")));
};
export default FavouriteToggle;
/**
 * Call API to update the favourite status of the specified item.
 */
async function setFavourite(payload) {
    try {
        const res = await fetch(API_URLS.favourites, {
            body: JSON.stringify(payload),
            headers: {
                accepts: 'application/json',
                'content-type': 'application/json',
            },
            method: 'post',
        });
        const data = (await res.json());
        return data;
    }
    catch (error) {
        return { value: payload.value };
    }
}
